import { render, staticRenderFns } from "./TemplateSendNotification.vue?vue&type=template&id=ceadd802&scoped=true&lang=pug"
import script from "./TemplateSendNotification.vue?vue&type=script&lang=js"
export * from "./TemplateSendNotification.vue?vue&type=script&lang=js"
import style0 from "./TemplateSendNotification.vue?vue&type=style&index=0&id=ceadd802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceadd802",
  null
  
)

export default component.exports